<template>
  <div class="program">
    <div v-if="icon" class="program-image">
      <CustomIcon :name="icon" />
    </div>
    <div class="program-content">
      <h4 class="program-title">{{ title }}</h4>
      <p class="program-description">{{ description }}</p>
    </div>
  </div>
</template>
<script>
import CustomIcon from "./CustomIcon.vue";
export default {
  name: "program-summary",
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    icon: String,
  },
  components: { CustomIcon },
};
</script>
